module.exports = __webpack_public_path__ + "static/media/modis2916.77ee3f71.jpg";